import React, { useState, useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Reservations.css';

gsap.registerPlugin(ScrollTrigger);

const Reservations = () => {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const sectionRef = useRef(null);
  const successRef = useRef(null);

  useEffect(() => {
    if (!submitted || !successRef.current) return;

    const ctx = gsap.context(() => {
      gsap.fromTo(
        successRef.current,
        { opacity: 0, scale: 0.8 },
        {
          opacity: 1,
          scale: 1,
          duration: 0.6,
          ease: 'back.out(1.4)',
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, [submitted]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    const formData = new FormData(e.target);
    fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSubmitted(true);
        } else {
          setError('Something went wrong. Please call us at (661) 679-4271.');
        }
      })
      .catch(() => {
        setError('Something went wrong. Please call us at (661) 679-4271.');
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <section id="inquiries" className="reservations" ref={sectionRef}>
      <div className="reservations__inner">
        <span className="eyebrow reveal">Private Events & Parties</span>
        <h2 className="section-title reveal d1">
          Let Us Make Your <em>Event</em> Special
        </h2>
        <div className="gold-divider reveal d2"><span className="dot"></span></div>

        {submitted ? (
          <div className="reservations__success" ref={successRef}>
            <span className="reservations__check-icon" aria-hidden="true">&#10003;</span>
            <p>Thank you! We'll be in touch soon to discuss your event.</p>
          </div>
        ) : (
          <form className="reservations__form" onSubmit={handleSubmit}>
            <input type="hidden" name="access_key" value="43f3a1d4-3a9c-4fdb-a1ca-39c75d278bd8" />
            <input type="hidden" name="subject" value="New Event Inquiry — Saffron" />
            <input type="hidden" name="from_name" value="Saffron Website" />
            <div className="form-grid">
              <div className="form-group">
                <input
                  type="text"
                  id="inq-name"
                  name="name"
                  required
                  placeholder=" "
                />
                <label htmlFor="inq-name">Name</label>
              </div>

              <div className="form-group">
                <input
                  type="email"
                  id="inq-email"
                  name="email"
                  required
                  placeholder=" "
                />
                <label htmlFor="inq-email">Email</label>
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  id="inq-phone"
                  name="phone"
                  required
                  placeholder=" "
                />
                <label htmlFor="inq-phone">Phone</label>
              </div>

              <div className="form-group form-group--select">
                <label htmlFor="inq-type">Event Type</label>
                <select id="inq-type" name="eventType" required defaultValue="" onChange={(e) => e.target.classList.toggle('has-value', e.target.value !== '')}>
                  <option value="" disabled>
                    Select event type
                  </option>
                  <option value="Catering">Catering</option>
                  <option value="Jagoo">Jagoo</option>
                  <option value="Sangeet">Sangeet</option>
                  <option value="Daytime Path">Daytime Path</option>
                  <option value="Baby Shower">Baby Shower</option>
                  <option value="Birthday Party">Birthday Party</option>
                  <option value="Corporate Event">Corporate Event</option>
                  <option value="Wedding / Reception">Wedding / Reception</option>
                  <option value="Anniversary">Anniversary</option>
                  <option value="Private Dining">Private Dining</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <input
                  type="text"
                  id="inq-date"
                  name="date"
                  placeholder=" "
                />
                <label htmlFor="inq-date">Preferred Date (MM/DD/YYYY)</label>
              </div>

              <div className="form-group form-group--select">
                <label htmlFor="inq-guests">Estimated Guests</label>
                <select id="inq-guests" name="estimatedGuests" defaultValue="" onChange={(e) => e.target.classList.toggle('has-value', e.target.value !== '')}>
                  <option value="" disabled>
                    Number of guests
                  </option>
                  <option value="10-25">10 - 25</option>
                  <option value="25-50">25 - 50</option>
                  <option value="50-100">50 - 100</option>
                  <option value="100+">100+</option>
                </select>
              </div>
            </div>

            <div className="form-group form-group--full form-group--textarea">
              <textarea
                id="inq-details"
                name="eventDetails"
                rows="4"
                placeholder=" "
              />
              <label htmlFor="inq-details">Tell Us About Your Event</label>
            </div>

            {error && <p style={{ color: '#e74c3c', marginBottom: '1rem' }}>{error}</p>}
            <button type="submit" className="btn btn-primary reservations__submit" disabled={submitting}>
              {submitting ? 'Sending...' : 'Send Inquiry'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default Reservations;
